import React from 'react';
import { Upload, CheckCircle } from 'lucide-react';
import { formatTime } from './ConsentVideoRecorder';

const ConsentReviewSubmit = ({
  recordedBlob,
  recordingTime,
  typeInfo,
  formData,
  loading,
  onReRecord,
  onSubmit
}) => (
  <div className="space-y-4">
    <h3 className="text-lg font-semibold text-gray-900">Review & Submit</h3>
    <p className="text-sm text-gray-600">Review the recorded video before submitting.</p>

    <div className="bg-black rounded-lg overflow-hidden aspect-video">
      <video
        src={recordedBlob ? URL.createObjectURL(recordedBlob) : ''}
        controls
        className="w-full h-full"
      />
    </div>

    <div className="bg-gray-50 rounded-lg p-4">
      <h4 className="font-medium text-gray-900 mb-2">Recording Summary</h4>
      <div className="grid grid-cols-2 gap-2 text-sm">
        <div><span className="text-gray-500">Duration:</span> {formatTime(recordingTime)}</div>
        <div><span className="text-gray-500">Consent Type:</span> {typeInfo?.name}</div>
        <div><span className="text-gray-500">Procedure:</span> {formData.procedure_name}</div>
        <div><span className="text-gray-500">Physician:</span> {formData.attending_physician}</div>
      </div>
    </div>

    <div className="flex justify-between">
      <button
        onClick={onReRecord}
        className="px-4 py-2 border rounded-lg hover:bg-gray-50"
      >
        Re-record
      </button>
      <button
        onClick={onSubmit}
        disabled={loading}
        className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50"
      >
        {loading ? (
          <>Uploading...</>
        ) : (
          <>
            <Upload className="h-5 w-5" />
            Submit Consent
          </>
        )}
      </button>
    </div>
  </div>
);

export default ConsentReviewSubmit;
